export default "__VITE_ASSET__CjNccY8U__"